import React from "react";
import { css } from "emotion";

import Container from "components/shared/Container";
import SlideShow from "components/home/SlideShow";
import Info from "components/home/Info";
import FeaturedProducts from "components/home/FeaturedProducts";

const pageContentWrapper = css``;

interface Props {}

const Home: React.FC<Props> = () => {
  return (
    <div className={pageContentWrapper}>
      <Container className="container">
        <SlideShow />
      </Container>
      <Info />
      <Container className="container">
        <FeaturedProducts />
      </Container>
    </div>
  );
};

export default Home;
